import React, {useEffect} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {Button, Dialog, DialogContent, DialogTitle, Stack, Typography,} from '@mui/material';
import {yupResolver} from '@hookform/resolvers/yup';
import {useGetPrevServElemById, useUpdatePrevServElem, validationSchemaPrevServElem,useGetPrevServElemDTOById} from './ServicesSE';
import {FormField} from '../../common/FormField';
import {
    useFieldsPrevServElem1,
    useFieldsPrevServElem2,
    useFieldsPrevServElem3,
    useFieldsPrevServElem4, useFieldsPrevServElem5
} from './FormPreventivi';
import {PrevServElem, PrevServElemDTO} from './types';


interface PreventiviEditCEROWProps {
  open: boolean;
  onClose: () => void;
  idprevservelemprop: number; // ✅ FIXED TYPE
}

const PreventiviEditCEROW: React.FC<PreventiviEditCEROWProps> = ({
  open,
  onClose,
  idprevservelemprop,
}) => {
  /* ================= FORM ================= */
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<PrevServElem>({
    resolver: yupResolver(validationSchemaPrevServElem),
  });

  const {
    control: controlDTO,
    reset: resetDTO,
    watch: watchDTO,
    setValue: setValueDTO,
    formState: { errors: errorsDTO },
  } = useForm<PrevServElemDTO>({
    // resolver: yupResolver(validationSchemaPrevServElem),
  });



//console.log(errors);
const numanalisi = watch('numanalisi');
const numconf = watch('numconf');
const numform = watch('numform');
const numprep = watch('numprep');


  /* ================= FIELDS ================= */
  const fieldsPrevServElem1 = useFieldsPrevServElem1();
  const fieldsPrevServElem2 = useFieldsPrevServElem2();
  const fieldsPrevServElem3 = useFieldsPrevServElem3();
  const fieldsPrevServElem4 = useFieldsPrevServElem4();
  const fieldsPrevServElem5 = useFieldsPrevServElem5();



  /* ================= DATA ================= */
  const { data: dataServElem } =
    useGetPrevServElemById(idprevservelemprop);

  const { data: dataServElemDTO  } =
    useGetPrevServElemDTOById(idprevservelemprop);

  const prevservelem = dataServElem?.results?.[0];

  const prevservelemdto = dataServElemDTO?.results?.[0];


  useEffect(() => {
  const total =
    (Number(numanalisi) || 0) +
    (Number(numconf) || 0) +
    (Number(numform) || 0) +
    (Number(numprep) || 0);

  setValue('numtot', total, { shouldValidate: true });
}, [numanalisi, numconf, numform, numprep, setValue]);


  /* ================= INIT ================= */
 useEffect(() => {
  if (prevservelem) {
    reset(prevservelem);
  }
}, [prevservelem, reset]);

useEffect(() => {
  if (prevservelemdto) {
    resetDTO(prevservelemdto);
  }
}, [prevservelemdto, resetDTO]);

  /* ================= MUTATION ================= */
  const { mutateAsync: updatePrevServElem, isPending } =
    useUpdatePrevServElem();

  /* ================= SUBMIT ================= */
  const onSubmit: SubmitHandler<PrevServElem> = async data => {
    await updatePrevServElem(data);
    onClose();
  };

  /* ================= UI ================= */
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography variant="h6">Modifica Riga Preventivo</Typography>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
             {fieldsPrevServElem1.map(f => (  <FormField  key={String(f.name)} control={controlDTO} field={f} /> ))}
            </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevServElem2.map(f => (  <FormField  key={String(f.name)} control={controlDTO} field={f} /> ))}
           </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevServElem3.map(f => (  <FormField  key={String(f.name)} control={controlDTO} field={f} /> ))}
           </Stack>
            <Stack direction="row"  spacing={2}>
          {fieldsPrevServElem4.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>
             <Stack direction="row"  spacing={2}>
          {fieldsPrevServElem5.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button onClick={onClose} color="error">
                Annulla
              </Button>
              <Button type="submit" variant="contained" disabled={isPending}>
                {isPending ? 'Salvando…' : 'Salva'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PreventiviEditCEROW;
